// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
//import login from '@/views/main';

//首页
import main from '@/views/main';
// 首页
//import index from '@/views/index';

import Rwsc from '@/views/rwsc/rwsc';
import HTIndex from '@/views/htgl/index';
// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  //mode: 'history',
    routes: [{
        path: '/',
        name: '首页',
        component: main,
        children: [
          {
            path: '',
            name: '背景素材',
            component: ()=>import('@/views/rwsc/bjsc.vue')
          },
          {
            path: '/bjsc',
            name: '背景素材',
            component: ()=>import('@/views/rwsc/bjsc.vue')
          },
          {
          path: '/rwsc',
          name: '人物素材',
          component: ()=>import('@/views/rwsc/rwsc.vue')
        },

          {
            path: '/bqsc',
            name: '表情素材',
            component: ()=>import('@/views/rwsc/bqsc.vue')
          },
          {
            path: '/txsc',
            name: '特效素材',
            component: ()=>import('@/views/rwsc/txsc.vue')
          },
          {
            path: '/yxsc',
            name: '音效素材',
            component: ()=>import('@/views/rwsc/yxsc.vue')
          },
          {
            path: '/djsc',
            name: '道具素材',
            component: ()=>import('@/views/rwsc/djsc.vue')
          },
          {
            path: '/bgmsc',
            name: 'BGM素材',
            component: ()=>import('@/views/rwsc/bgmsc.vue')
          },
          {
            path: '/spjc',
            name: '视频教程',
            component: ()=>import('@/views/rwsc/spjc.vue')
          },
          {
            path: '/rjxz',
            name: '软件下载',
            component: ()=>import('@/views/rwsc/rjxz.vue')
          }
        ]
    },
      {
        path: '/htIndex',
        name: '后台管理首页',
        component: HTIndex,
        children: [{
          path: '/userlist',
          name: '用户管理',
          component: ()=>import('@/views/htgl/user/list.vue')
        },
          {
            path: '/userdetail',
            name: '用户表单',
            component: ()=>import('@/views/htgl/user/detail.vue')
          },
          {
            path: '/userpwd',
            name: '修改密码',
            component: ()=>import('@/views/htgl/user/updatepwd.vue')
          },
          {
            path: '/rwgllist',
            name: '人物管理',
            component: ()=>import('@/views/htgl/rwgl/list.vue')
          },
          {
            path: '/rwgldetail',
            name: '人物表单',
            component: ()=>import('@/views/htgl/rwgl/detail.vue')
          },
          {
            path: '/bjgllist',
            name: '背景管理',
            component: ()=>import('@/views/htgl/bjgl/list.vue')
          },
          {
            path: '/bjgldetail',
            name: '背景表单',
            component: ()=>import('@/views/htgl/bjgl/detail.vue')
          },
          {
            path: '/djgllist',
            name: '道具管理',
            component: ()=>import('@/views/htgl/djgl/list.vue')
          },
          {
            path: '/djgldetail',
            name: '道具表单',
            component: ()=>import('@/views/htgl/djgl/detail.vue')
          },
          {
            path: '/bqgllist',
            name: '表情管理',
            component: ()=>import('@/views/htgl/bqgl/list.vue')
          },
          {
            path: '/bqgldetail',
            name: '表情表单',
            component: ()=>import('@/views/htgl/bqgl/detail.vue')
          },
          {
            path: '/txgllist',
            name: '特效管理',
            component: ()=>import('@/views/htgl/txgl/list.vue')
          },
          {
            path: '/txgldetail',
            name: '特效表单',
            component: ()=>import('@/views/htgl/txgl/detail.vue')
          },
          {
            path: '/yxgllist',
            name: '音效管理',
            component: ()=>import('@/views/htgl/yxgl/list.vue')
          },
          {
            path: '/yxgldetail',
            name: '音效表单',
            component: ()=>import('@/views/htgl/yxgl/detail.vue')
          },
          {
            path: '/spgllist',
            name: '视频管理',
            component: ()=>import('@/views/htgl/spgl/list.vue')
          },
          {
            path: '/spgldetail',
            name: '视频表单',
            component: ()=>import('@/views/htgl/spgl/detail.vue')
          },
          {
            path: '/rjgllist',
            name: '软件管理',
            component: ()=>import('@/views/htgl/rjgl/list.vue')
          },
          {
            path: '/rjgldetail',
            name: '软件管理',
            component: ()=>import('@/views/htgl/rjgl/detail.vue')
          },
          {
            path: '/bgmgllist',
            name: 'BGM管理',
            component: ()=>import('@/views/htgl/bgm/list.vue')
          },
          {
            path: '/bgmgldetail',
            name: 'BGM表单',
            component: ()=>import('@/views/htgl/bgm/detail.vue')
          },
          {
            path: '/cjzc',
            name: '插件注册',
            component: ()=>import('@/views/htgl/cj/cjzc.vue')
          },
        ]
      }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js